import { IProcedure } from '../Procedure';
import { ICitizen } from '../Citizen';
import { IReadingRequestDocument } from '../ReadingRequestDocument';
import { JobStatus } from 'bull';
import { ICommissionRank } from 'server/schema/procedure/request-ranking/CommissionRank';
import { ISiapUserInfo } from 'server/schema/user/siap/services/SiapGetUserInfo';

export enum RequestState {
  Draft = 'Draft',
  Sending = 'Sending',
  NeedRetry = 'NeedRetry',
  Sent = 'Sent',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Tested = 'Tested'
}

export interface IRequest {
  id: number;

  // Cittadino (autore) della richiesta
  citizenId?: number | null;
  citizen?: ICitizen | null;

  // Livello di autorizzazione SPID
  spidLevel?: string;

  authorMail: string;
  authorName: string;
  authorFamilyName: string;
  subject: string;

  state: RequestState;

  procedureId: number;
  procedure: IProcedure;

  values: IRequestValues;

  code?: string | null;
  sentAt?: Date | null;
  dossierId?: number | null;
  dossierCode?: string | null;
  documentId?: number | null;

  protocolSignature?: string | null;
  protocolDate?: Date | null;

  createdAt: Date;
  updatedAt: Date;

  /** Relazione autore-request-documento per flag visualizzazione */
  readingRequestDocumentsId?: number | null;
  readingRequestDocuments?: IReadingRequestDocument[] | null;

  /** Stato del job (sola lettura) */
  jobStatus?: JobStatus;

  /** Punteggio della richiesta */
  commissionRanks?: ICommissionRank[] | null;

  /** Punteggio delle regole */
  totalRulesPoints?: number | null;

  /** Punteggio della commissione */
  totalCommissionPoints?: number | null;

  /** Dati utente SIAP */
  siap?: ISiapUserInfo | null;
}

export type IRequestWithCitizen = IRequest & {
  citizenId: number;
  citizen: ICitizen;
};

export interface IRequestValues {
  [metadataId: string]: IRequestValue;
}

export type IRequestValue =
  | boolean
  | string
  | number
  | Date
  | IRequestFileValue
  | IRequestListValue;

export interface IRequestFileItem {
  fileName: string;
  attachmentId: string;
  size: number;
  type: string;
  metadataId?: string;
}
export type IRequestFileValue = Array<IRequestFileItem>;

export type IRequestListRow = {
  isPlaceholder?: boolean;
  values: IRequestValues;
};
export type IRequestListValue = Array<IRequestListRow>;
